import gettext from '@eb/gettext';

export * from './header';
export * from './notifications';
export * from './schedule';
export * from './structure';

export {
    ERROR_CANCEL_REFUND,
    ERROR_CANCEL_REFUND_WITH_BULK_ENABLED,
} from '../event/api';

export const EVENTS_PAGE_PATH = '/organizations/events';
export const ACTION_EVENT_PREVIEW = 'EventPreview';
export const ACTION_EVENT_PUBLISH = 'EventPublished';
export const ACTION_FIRST_COYOTE_PAID_PUBLISH = 'FirstCoyotePaidPublish';
export const ACTION_FIRST_COYOTE_PUBLISH = 'FirstCoyotePublish';
export const ACTION_FIRST_PAID_PUBLISH = 'FirstPaidPublish';
export const ACTION_FIRST_PUBLISH = 'FirstPublish';
export const ACTION_LEFT_NAV_LINK_CLICKED = 'LeftNavLinkClick';
export const ACTION_INCREMENTAL_PUBLISH = 'IncrementalPublish';
export const ACTION_PUBLISH = 'Publish';
export const EVENT_DASHBOARD_BASE = '/myevent';
export const GA_EVENT_PUBLISHED = 'EventPublished';
export const GA_EVENT_STATUS_DRAFT_LABEL = 'draft';
export const GA_EVENT_STATUS_LIVE_LABEL = 'live';
export const GA_GOAL_CATEGORY = 'goal';
export const GA_MANAGE_CATEGORY = 'manage';
export const GA_MANAGE_MY_EVENTS_LABEL = 'ManageMyEvents';
export const GA_DASHBOARD_LABEL = 'Dashboard';
export const GA_SALES_STATUS_ACTION_POSTPONE_CONFIRMED =
    'PostponeEventStatusConfirmed';
export const GA_TRACKING_EVENT_CATEGORY = 'create-event';
export const GA_TRACKING_LOCATION_ON_PAGE_GH = 'Global Header';
export const LABEL_NEW_CREATE = 'coyote';
// Marketing Tools Experiment
export const VARIANT_C = 'C';

//constants
export const MANAGE_MY_EVENTS_LABEL = gettext('Manage my events');

// GA tracking
export const GA_ACTION_PROFILE_DROPDOWN = 'ProfileDropdown';
export const GA_CATEGORY_HEADER = 'header';
export const GA_LABEL_CREATOR_EVENT = 'ViewFromCreatorEvent';
